import { Box, BoxProps } from "@mui/material";
import React from "react";

interface ContainerProps extends BoxProps {
	children: React.ReactNode;
}

const Container: React.FC<ContainerProps> = ({ children, ...rest }) => {
	return (
		<Box
			maxWidth={{ sm: 720, md: 800 }}
			width={1}
			margin={"0 auto"}
			p={1}
			{...rest}>
			{children}
		</Box>
	);
};

export default Container;
